<template>
  <router-link :to="{ name: 'group', params: { id: data.id } }" class="group-card">
    <ImgComponent :head_img="data.img" />
    <div class="group-card__text">
      <h4 class="group-card__title">{{ data.title }}</h4>
      <router-link :to="{ name: '' }" class="group-card__route"
        >Подробнее
        <IconComponent name="arrow-right" />
      </router-link>
    </div>
  </router-link>
</template>

<script>
import ImgComponent from "components/ImgComponent.vue";
import IconComponent from "components/IconComponent.vue";
export default {
  name: "GroupCard",
  props: {
    data: {
      type: Object,
    },
  },
  components: { IconComponent, ImgComponent },
};
</script>

<style lang="stylus">
.group-card {
  filter: drop-shadow(0px 4px 43px #EAEAF2);
  cursor pointer
  border-radius 20px
  overflow: hidden;

  img {
    //position: absolute;
  }

  &__title {
    color var(--white)
  }

  &__text {
    display flex
    flex-direction column
    gap 10px
    z-index 5
    position absolute
    bottom 30px
    left 30px

    +below(1024px) {
      bottom 20px
      left 20px
      gap 4px
    }
  }

  &__route {
    cursor pointer
    display flex
    gap 4px
    align-items: center;
    font-weight: 500;
    font-size: 1.25em;
    line-height: 160%;
    color: var(--red);
    transition var(--transition)

    +below(1024px) {
      font-size: 1em;
      line-height: 160%;
    }

    &:hover {
      color: var(--main);
      svg path {
        fill var(--main)
      }
    }
    svg {
      width: 22px;
      path {
        fill var(--red)
        transition var(--transition)
      }
    }
  }


}
</style>
